import { render, staticRenderFns } from "./add.vue?vue&type=template&id=19e21d38&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e21d38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19e21d38')) {
      api.createRecord('19e21d38', component.options)
    } else {
      api.reload('19e21d38', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=19e21d38&scoped=true", function () {
      api.rerender('19e21d38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/protocolCompliance/protocolManage/components/add.vue"
export default component.exports